export default "__VITE_ASSET__DXZpsj3A__"